<template>
  <h3>
    <expand-collapse
      v-bind:expanded="expanded"
      v-on:toggle="$emit('toggle')"
    />
    {{ title }}
  </h3>
</template>

<script>
import ExpandCollapse from '@/components/utilities/expand-collapse';

export default {
  name: 'header-with-toggle',
  props: ['title', 'expanded'],
  components: {
    'expand-collapse': ExpandCollapse,
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/utilities/header-with-toggle.vue